import { useState, type FormEvent } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { api, setActor, setAdminPassword } from "@/lib/api";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
}

export function AdminLogin({ open, onOpenChange, onSuccess }: Props) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    const fd = new FormData(e.currentTarget);
    const password = String(fd.get("password") ?? "");
    const actor = String(fd.get("actor") ?? "").trim();
    try {
      await api.login(password);
      setAdminPassword(password);
      if (actor) setActor(actor);
      onSuccess();
      onOpenChange(false);
    } catch (err: any) {
      setError(err?.message ?? "login failed");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogTitle>PM access</DialogTitle>
        <DialogDescription>
          Sign in to add or edit initiatives. Read-only stays open for everyone.
        </DialogDescription>
        <form onSubmit={handleSubmit} className="grid gap-3 mt-4">
          <label className="grid gap-1.5">
            <span className="text-xs font-medium text-muted-foreground">Your name</span>
            <Input name="actor" placeholder="e.g. Yehor M." required />
          </label>
          <label className="grid gap-1.5">
            <span className="text-xs font-medium text-muted-foreground">Admin password</span>
            <Input name="password" type="password" required autoFocus />
          </label>
          {error && (
            <div className="rounded-md border border-destructive/40 bg-destructive/10 px-3 py-2 text-sm text-destructive">
              {error}
            </div>
          )}
          <Button type="submit" disabled={submitting}>
            {submitting ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
